/* resources/js/components/mainDrawer.js
 * Alpine factory for <x‑up.main4>
 */
export default function drawerFactory(
  {
    wireModel          = null,
    mode               = 'overlay',
    drawerWidthOverlay,
    drawerWidthSidebar,
    largeScreenPx      = 800,
    startOpen          = false,
    startOpenLarge     = false,
    closeOnEscape      = false,
    withoutTrapFocus   = false,
    right              = false,
    name               = 'mainDrawer',
    debug              = false,
  } = {}
) {
  return {
    /* ── config exposed to Blade ───────────────────────── */
    drawerWidthOverlay,
    drawerWidthSidebar,
    right,
    withoutTrapFocus,
    closeOnEscape,

    /* ── reactive state ───────────────────────────────── */
    isOpen: wireModel ?? false,
    isOverlay: false,

    /* ── lifecycle ────────────────────────────────────── */
    init() {
      this.checkForInitOpen();
      this.updateOverlayMode();
      this.listenOnEvents();
      if (debug) console.log('Drawer init', name, this.isOpen, this.isOverlay);
    },

    /* ── helpers ──────────────────────────────────────── */
    toggle() { this.isOpen = !this.isOpen },
    open()   { this.isOpen = true  },
    close()  { this.isOpen = false },

    checkForInitOpen() {
      if (startOpenLarge) {
        this.isOpen = window.innerWidth >= largeScreenPx;
      } else if (startOpen) {
        this.isOpen = true;
      }
    },

    updateOverlayMode() {
      this.isOverlay =
        mode === 'overlay' ||
        (mode === 'responsive' && window.innerWidth < largeScreenPx);
    },

    listenOnEvents() {
      /* — resize — */
      window.addEventListener('resize', () => this.updateOverlayMode());

      /* — Livewire events — */
      if (window.Livewire) {
        // define ui **before** we subscribe, avoiding TDZ errors
        const ui = window.Livewire?.wireUi ?? {
          OpenDrawer:  'open-drawer',
          CloseDrawer: 'close-drawer',
          ToggleDrawer:'toggle-drawer',
        };

        Livewire.on(ui.OpenDrawer,  ({ name: n }) => n === name && this.open());
        Livewire.on(ui.CloseDrawer, ({ name: n }) => n === name && this.close());
        Livewire.on(ui.ToggleDrawer,({ name: n }) => n === name && this.toggle());
      } else if (debug) {
        console.warn('Livewire not found – drawer will not receive events');
      }

      /* — Alpine store sync (optional) — */
      Alpine.store('maindrawer', {
        isOpen: false,
        toggle() { this.isOpen = !this.isOpen },
        close()  { this.isOpen = false },
        open()   { this.isOpen = true  },
      });

      this.$watch('isOpen', val => (Alpine.store('maindrawer').isOpen = val));
    },
  };
}
